import { Component, Input } from '@angular/core';
import { InvoicesByDate } from '../../models/invoices-list-balance.model';

@Component({
  selector: 'my-bill-slice-invoice-item',
  templateUrl: './my-bill-slice-invoice-item.component.html',
  standalone: false,
})
export class MyBillSliceInvoiceItemComponent {
  @Input() invoicesByDate: InvoicesByDate;
  @Input() sliceDetailsNumber: number;
  @Input() hasOpenStatus = false;
}
